export const pageDataSelector = (state) => state.page;

export const landingDataSelector = (state) => state.page.landing;

export const pageLocalVersionSelector = (state) => state.page?.localVersion;

export const getLandingCurrentPhotos = (state, pageIndex, sectionIndex, blockIndex) => {
  const landingData = landingDataSelector(state);
  const currentFiles = landingData?.pages[pageIndex]?.blocks[blockIndex]?.data?.files;
  return currentFiles;
};

export const getLandingLinkName = (state) => {
  const currentStep = state.page?.currentStep || '';
  const linkName = currentStep === 'page' ? 'Page' : 'New Page';
  return linkName;
};

export const pageDataRoomsSelector = (state) => state.page?.rooms || null;

export const formatRoomsSelector = (state, localRooms = []) => {
  const rooms = pageDataRoomsSelector(state) || localRooms;
  return rooms.map((room) => {
    const name = room?.name || '';

    const data = [
      {
        type: 'boldText',
        data: {
          raw: {
            blocks: [
              {
                key: 'frbl6',
                text: name,
                type: 'unstyled',
                depth: 0,
                inlineStyleRanges: [{ offset: 0, style: 'BOLD', length: name.length }],
                entityRanges: [],
                data: {},
              },
            ],
            entityMap: {},
          },
        },
      },
      {
        type: 'text',
        data: {
          text: room?.description,
        },
      },
      {
        type: 'image',
        data: {
          files: room?.media,
        },
      },
      {
        type: 'video',
        data: {
          files: room?.videos,
        },
      },
    ];
    return { id: room.id, data };
  });
};

export const getPagePoliciesSelector = (state) => {
  const policies = state?.page?.policies;
  return {
    isCanDuplicate: policies?.duplicate,
    isCanUpdate: policies?.update,
    isCanDestroy: policies?.destroy,
    isCanPending: policies?.pending,
  };
};

export const getPageStatusSelector = (state) => {
  return state?.page?.status;
};

export const getInitialRoomPositionsSelector = (state) => {
  return state?.page?.initialRoomPositions;
};

export const getPageCustomStylesSelector = (state, pageIndex = 0) => {
  return state?.page?.landing?.pages?.[pageIndex]?.customStyles || '';
};

export const getPageCustomFontsSelector = (state, pageIndex = 0) => {
  return state?.page?.landing?.pages?.[pageIndex]?.customFonts || [];
};
